export const Pencil = () => {
    return (
        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_249_62390)">
                <path d="M8.08763 16.6248H18.375V18.3748H2.625V14.6622L11.2875 5.9997L14.9993 9.7132L8.08675 16.6248H8.08763ZM12.5239 4.76333L14.3806 2.90658C14.5447 2.74254 14.7672 2.65039 14.9993 2.65039C15.2313 2.65039 15.4538 2.74254 15.6179 2.90658L18.0932 5.38195C18.2573 5.54604 18.3494 5.76856 18.3494 6.00058C18.3494 6.2326 18.2573 6.45512 18.0932 6.6192L16.2365 8.47508L12.5247 4.76333H12.5239Z" fill="currentColor" />
            </g>
            <defs>
                <clipPath id="clip0_249_62390">
                    <rect width="21" height="21" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}